import { render, staticRenderFns } from "./huiyuan.vue?vue&type=template&id=2c74a1f8&scoped=true"
import script from "./huiyuan.vue?vue&type=script&lang=js"
export * from "./huiyuan.vue?vue&type=script&lang=js"
import style0 from "./huiyuan.vue?vue&type=style&index=0&id=2c74a1f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c74a1f8",
  null
  
)

export default component.exports